// extracted by mini-css-extract-plugin
export default {"plansContainer":"Plans_plansContainer__OP+k4","mainContent":"Plans_mainContent__cRJQd","plansMain":"Plans_plansMain__w8Thp"};